import inEU from '@segment/in-eu';
import 'vanilla-cookieconsent';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    // Must stay identical to the declarations in apps/console/src/utils/gtm.ts
    // and apps/dashboard/client/GTM.ts — TypeScript merges global Window
    // declarations and errors if the modifiers or types differ.
    dataLayer?: { event?: string; [key: string]: unknown }[];
  }
}

export type InitEuConsentAndGAOptions = {
  ga_id: string;
  on_analytics_accepted: () => void;
  on_analytics_rejected?: () => void;
};

const load_ga_script = (ga_id: string) => {
  if (window.gtag || !ga_id) {
    return;
  }
  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${ga_id}`;
  head.appendChild(script);
  const script_init = document.createElement('script');
  script_init.textContent = `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${ga_id}');
  `;
  head.appendChild(script_init);
};

export const initEuConsentAndGA = ({
  ga_id,
  on_analytics_accepted,
  on_analytics_rejected,
}: InitEuConsentAndGAOptions): void => {
  if (!inEU()) {
    load_ga_script(ga_id);
    on_analytics_accepted();
    return;
  }

  const cookie_consent = window.initCookieConsent?.();
  if (!cookie_consent) {
    on_analytics_rejected?.();
    return;
  }

  cookie_consent.run({
    current_lang: 'en',
    languages: {
      en: {
        consent_modal: {
          title: 'Our website uses cookies',
          description:
            'Hookdeck would like to use our own and third party cookies and similar technologies for analytics purposes.',
          primary_btn: { text: 'Accept', role: 'accept_all' },
          secondary_btn: { text: 'Reject', role: 'accept_necessary' },
          revision_message: '',
        },
        settings_modal: {
          title: '',
          save_settings_btn: '',
          accept_all_btn: '',
          reject_all_btn: '',
          close_btn_label: '',
          cookie_table_headers: [],
          blocks: [
            {
              title: 'Analytics',
              description: '',
              toggle: { value: 'analytics', enabled: false, readonly: false },
            },
          ],
        },
      },
    },
    gui_options: {
      consent_modal: {
        layout: 'cloud',
        position: 'bottom center',
        swap_buttons: false,
      },
    },
    onAccept: (pref: { categories?: string[] }) => {
      if (pref.categories?.includes('analytics')) {
        load_ga_script(ga_id);
        on_analytics_accepted();
      } else {
        on_analytics_rejected?.();
      }
    },
  });
};
